// src/ChangePassword.js
import React, { useState } from "react";
import { changePassword } from "./api";

export default function ChangePassword({ user, onDone, onLogout }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!currentPassword || !newPassword || !confirm) {
      setError("All fields are required.");
      return;
    }
    if (newPassword !== confirm) {
      setError("New passwords do not match.");
      return;
    }

    setBusy(true);
    try {
      await changePassword(currentPassword, newPassword);
      setSuccess("Password updated. You can now continue.");
      if (onDone) onDone();
    } catch (err) {
      const msg =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        err?.message ||
        "Failed to change password.";
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: 520, marginTop: "10vh" }}>
      <div className="card shadow-sm">
        <div className="card-header">
          <strong>Change your password</strong>
        </div>
        <div className="card-body">
          <p className="text-muted small">
            {user?.email
              ? `Welcome, ${user.email}. You must update your password before using the console.`
              : "You must update your password before using the console."}
          </p>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Current password</label>
              <input
                type="password"
                className="form-control"
                autoComplete="current-password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">New password</label>
              <input
                type="password"
                className="form-control"
                autoComplete="new-password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Confirm new password</label>
              <input
                type="password"
                className="form-control"
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
              />
            </div>

            {error && <div className="alert alert-danger py-2">{error}</div>}
            {success && (
              <div className="alert alert-success py-2">{success}</div>
            )}

            <div className="d-flex justify-content-between align-items-center">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={busy}
              >
                {busy ? "Updating..." : "Update password"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={onLogout}
              >
                Sign out
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
